import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import './common.css';
import Login from './pages/Login/Login';
import Signup from './pages/Signup/Signup';
import SignupSuccess from './pages/SignupSuccess/SignupSuccess';
import Dashboard from './pages/Dashboard/Dashboard';
import NewUserContent from './components/NewUserContent/NewUserContent';
import Report from './components/Report/Report';
import ConfirmSignup from './pages/ConfirmSignup/ConfirmSignup';
import { useDispatch, useSelector } from 'react-redux';
import { useEffect } from 'react';
import ForgotPassword from './pages/ForgotPassword/ForgotPassword';
import AccountRecover from './pages/AccountRecover/AccountRecover';
import Setting from './pages/Setting/Setting';
import Home from './pages/Home/Home';
import Consent from './pages/Consent/Consent';
import AllSet from './pages/AllSet/AllSet';
import { axiosInstance } from './config/axiosConfig';
import { useState } from 'react';
import { GET_USER_AGREEMENT } from './config/endpoint';
import { getUserIsAggreed } from './redux/slice/userAgreementSlice';
import AllConsents from './pages/AllConsents/AllConsents';
import DashboardLayout from './pages/DashboardLayout/DashboardLayout';
import MyData from './pages/MyData/MyData';
import ContactUs from './pages/ContactUs/ContactUs';
import Onboarding from './pages/Onboarding/Onboarding';
import ChatWithData from './pages/ChatWithData/ChatWithData';
import DataVisulization from './pages/DataVisulization/DataVisulization';
import ConnectDB from './pages/ConnectDB/ConnectDB';
import Pricing from './pages/Pricing/Pricing';
import SubscriptionPayment from './pages/SubscriptionPayment/SubscriptionPayment';
import BrainyDash from './pages/BrainyDash/BrainyDash';

function App() {
  const token = localStorage.getItem('token')
  const dispatch = useDispatch()
  const location = useLocation()
  const userAgreement = useSelector((state) => state.userAgreement)
  const navigate = useNavigate()
  useEffect(() => {
    if (token) {
      dispatch(getUserIsAggreed())
    }
  }, [])

  useEffect(() => {
    if (location?.pathname == '/') {
      if (userAgreement?.isLoaded) {
        if (userAgreement?.isAgreed) {
          navigate('/dashboard/all-set')
        } else {
          navigate('/onboarding')
        }
      }
    }
  }, [userAgreement?.isAgreed, userAgreement?.isLoaded])


  return (
    <>
      <Routes>
        {
          token ?
            <>
              <Route path='brainy-dashboard' Component={BrainyDash} />
              <Route path='onboarding' Component={Onboarding} />
              <Route path='new-user' Component={NewUserContent} />

              {userAgreement?.isLoaded &&
                <>
                  {<Route path='dashboard' Component={DashboardLayout}>
                    <Route path='' Component={Dashboard} />
                    {
                      (userAgreement?.isAgreed) && <>
                        <Route path='all-set' Component={AllSet} />
                      </>
                    }
                    <Route path='consent' Component={Consent} />
                    <Route path='my-data' Component={MyData} />
                    <Route path='*' element={<></>} />

                  </Route>
                  }
                  {/* {!userAgreement?.isAgreed &&
                    <>
                      <Route path='new-user' Component={NewUserContent} />
                      <Route path='*' element={<Navigate to={'/new-user'} />} />
                    </>
                  } */}

                </>
              }
            </> :
            <>
              <Route path='' Component={Home} />
              <Route path='login' Component={Login} />
              {/* <Route path='brainy-dashboard' Component={BrainyDash} /> */}
              <Route path='contact-us' Component={ContactUs} />
              <Route path='chat-with-data' Component={ChatWithData} />
              <Route path='data-visualization' Component={DataVisulization} />
              <Route path='subscription-payment' Component={SubscriptionPayment} />
              <Route path='connect-db' Component={ConnectDB} />
              <Route path='pricing' Component={Pricing} />
              <Route path='signup' Component={Signup} />
              <Route path='forgot-password' Component={ForgotPassword} />
              <Route path='account-recover' Component={AccountRecover} />
              <Route path='signup-success' Component={SignupSuccess} />
              <Route path='confirm-signup' Component={ConfirmSignup} />
            </>
        }


      </Routes>
    </>
  );
}

export default App;
